<template>
  <div class="detail-main">
    <Header ref="header"/>
    <div class="main-1200-width padding-bottom-40 list_box">
      <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>最新消息</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="list">
        <div class="item" v-for="(item,index) in list" :key="index">
          <div class="item_info">
            <router-link class="item_title" :title="item.title" :to="{name: 'NewsDetail',params:{id:item.id}}">{{ item.title }}</router-link>
            <div class="item_desc">描述：{{ item.content }}</div>
          </div>
          <div class="item_time">{{ item.publish_time_text }}</div>
        </div>
        <el-pagination
          v-if="count > 0"
          background
          layout="prev, pager, next"
          :page-size="limit"
          :total="total"
          @current-change="pageChange"
          class="page"
        >
        </el-pagination>
      </div>
      <div v-if="!list" class="no-data"><img src="@/assets/no_data.png" alt=""></div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Header from "@/globalComponents/Header";
import Footer from "@/globalComponents/Footer";

import dataApi from '@/api/data'
export default {
  data() {
    return {
      page : 1,
      limit: 10,
      list : {},
      count: 1,
      total: 1
    };
  },
  created() {
    this.getList();
  },
  methods   : {
    pageChange(e) {
      this.page = e;
      this.getList();
    },
   async getList() { //获取页面数据
      let that = this;
      let {data} = await dataApi.richtextList({page: that.page, list_rows: that.limit})
      that.list = data.data;
      that.page = data.current_page;
      that.count = data.last_page;
      that.total = data.total;
    },
  },
  components: {
    Header,
    Footer
  }
};
</script>
<style lang="less" scoped>
@import url("index.less");
</style>
